module.exports = __webpack_public_path__ + "img/Simple Green.023a31bb.jpg";